import { render } from "./ResetPasswordPage.vue?vue&type=template&id=7ba5c94e&ts=true"
import script from "./ResetPasswordPage.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordPage.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__